import { useState, useEffect } from "react"
import Categories from "./Categories.js"
import Resources from "./Resources.js"

const Gameboard = ({ setScore, score, activeCert, resetCertScore }) => {
  const [cluesAnsweredByCert, setCluesAnsweredByCert] = useState({
    admin1: 0,
    admin2: 0,
    "app-builder": 0,
    "business-analyst": 0,
    developer1: 0,
  })
  const [category, setCategory] = useState(false)
  const [resetKey, setResetKey] = useState(0)

  const cluesAnswered = cluesAnsweredByCert[activeCert] || 0

  const setCluesAnswered = (valueOrUpdater) => {
    setCluesAnsweredByCert((prev) => ({
      ...prev,
      [activeCert]:
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev[activeCert] || 0)
          : valueOrUpdater,
    }))
  }

  const resetGame = () => {
    setCluesAnsweredByCert((prev) => ({ ...prev, [activeCert]: 0 }))
    resetCertScore()
    setResetKey((prev) => prev + 1)
  }

  // Close modal when certification changes
  useEffect(() => {
    setCategory(false)
  }, [activeCert])

  return (
    <>
      {cluesAnswered > (activeCert === "app-builder" ? 24 : activeCert === "business-analyst" ? 29 : activeCert === "developer1" ? 19 : activeCert === "admin1" ? 39 : 34) && !category ? (
        <div className="centered-resources">
          <Resources score={score} activeCert={activeCert} onRestart={resetGame} />
        </div>
      ) : (
        <div id="gameboard" className={activeCert === "app-builder" ? "cols-5" : activeCert === "business-analyst" ? "cols-6" : activeCert === "developer1" ? "cols-4" : activeCert === "admin1" ? "cols-8" : ""}>
          <Categories
            key={resetKey}
            setScore={setScore}
            setCluesAnswered={setCluesAnswered}
            cluesAnswered={cluesAnswered}
            category={category}
            setCategory={setCategory}
            activeCert={activeCert}
          />
        </div>
      )}
    </>
  )
}

export default Gameboard
